import React from 'react';
import { cn } from '@lib/utils';

export type RoleBadgeRole = 'admin' | 'moderator' | 'host';

const LABEL: Record<RoleBadgeRole, string> = {
  admin: 'Admin',
  moderator: 'Moderator',
  host: 'Host',
};

const TONE: Record<RoleBadgeRole, string> = {
  admin: 'bg-mb-yellow-pale text-mb-gold',
  host: 'bg-mb-yellow-pale text-mb-gold',
  moderator: 'bg-blue-100 text-blue-700',
};

/** Role pill on member and attendee rows (Admin / Moderator / Host). */
export const RoleBadge: React.FC<{ role: RoleBadgeRole; className?: string }> = ({
  role,
  className,
}) => (
  <span
    className={cn(
      'inline-flex shrink-0 items-center whitespace-nowrap rounded-full px-2 py-0.5 text-[10px] font-semibold leading-none',
      TONE[role],
      className,
    )}
  >
    {LABEL[role]}
  </span>
);
